<template>
  <DocumentView api-type="invoices" type="Facture" />
</template>

<script>
import DocumentView from '@/components/Templates/DocumentView'

export default {
  components: {
    DocumentView,
  },
}
</script>
